import * as apiGet from 'api/channel/GetChannelIdV1';
import * as apiPost from 'api/channel/PostChannelV1';
import * as apiPut from 'api/channel/PutChannelV1';
import { Media } from 'api/media/PostMediaV1';
import * as apiPostMedia from 'api/media/PostMediaV1';
import * as apiPutMedia from 'api/media/PutMediaV1';
import * as apiTranslate from 'api/translation/PostTranslationV1';
import { MEDIACOLLECTION } from 'enums/mediaCollection';
import { IconSvg } from 'types/_general/IconSvg';
import { LocalizedTranslation } from 'types/_general/LocalizedTranslation';

export default class AccessoryCategory {
	public id: string = '';
	public nameTranslations: LocalizedTranslation<string> = {};
	iconSvg: IconSvg | null = null;

	public constructor(input?: apiGet.ResponseData) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiTranslation(fromCultureCode: string, toCultureCode: string): Promise<void> {
		const response = await apiTranslate.callApi(
			this.mapToApiTranslate(fromCultureCode, toCultureCode)
		);
		response.hasValue() && this.mapFromApiTranslate(response.get(), toCultureCode);
	}

	public async callApiPut(): Promise<void> {
		await apiPut.callApi(this.id, this.mapToApiPut());
	}

	public async callApiPost(): Promise<void> {
		const response = await apiPost.callApi(this.mapToApiPost());
		response.hasValue() && this.mapFromApiPost(response.get());
	}

	public async callApiUploadMedia(input: FormData | null): Promise<void> {
		let response = null;
		response = await apiPostMedia.callApi(this.mapToApiMedia(input) as apiPostMedia.Request);
		response.hasValue() && this.mapFromApiUploadMedia(response.get());
	}

	private mapToApiMedia(
		formData: FormData | null,
		id?: string
	): apiPostMedia.Request | apiPutMedia.Request {
		if (id) {
			return {
				id: id,
				mediaCollection: MEDIACOLLECTION.Icon,
				formData: formData,
			};
		} else {
			return {
				mediaCollection: MEDIACOLLECTION.Icon,
				formData: formData,
			};
		}
	}

	private mapToApiTranslate(
		fromCultureCode: string,
		toCultureCode: string
	): apiTranslate.Request {
		return {
			fromCultureCode: fromCultureCode,
			toCultureCode: toCultureCode,
			text: this.nameTranslations[fromCultureCode],
		};
	}

	private mapToApiPost(): apiPost.Request {
		return {
			nameTranslations: this.nameTranslations,
			iconSvgId: this.iconSvg?.id ?? null,
		};
	}

	private mapToApiPut(): apiPut.Request {
		return {
			nameTranslations: this.nameTranslations,
			iconSvgId: this.iconSvg?.id ?? null,
		};
	}

	private mapFromApi(input: apiGet.ResponseData) {
		this.id = input.id;
		this.nameTranslations = input.nameTranslations;
		this.iconSvg = input.iconSvg;
	}

	private mapFromApiUploadMedia(input: Media | null) {
		this.iconSvg = input;
	}

	private mapFromApiPost(input: string) {
		this.id = input;
	}

	private mapFromApiTranslate(input: string, toCultureCode: string) {
		this.nameTranslations[toCultureCode] = input;
	}
}
